<script>
  import { fade } from 'svelte/transition';
  
  const benefits = [
    {
      titleStart: 'Less',
      titleEnd: 'Noise',
      description: "AddMeetings filters out low-intent leads so your outreach reaches only professionals who match your target profile. Stop chasing random prospects start connecting with those actively looking for what you offer."
    },
    {
      titleStart: 'Smarter',
      titleEnd: 'Meetings',
      description: 'Every meeting request is pre-qualified using intent-based AI, ensuring you spend time only on meaningful conversations that move the needle forward. No wasted discovery calls. Just focused, productive discussions.'
    },
    {
      titleStart: 'Higher',
      titleEnd: 'Conversion',
      description: 'By engaging only with the right buyers at the right time, your conversion rate naturally rises without increasing outreach volume. More relevance, more trust, more results.'
    }
  ];
</script>

<section class="py-24">
  <div class="container mx-auto px-4 md:px-16 xl:px-32">
    <!-- Main Heading -->
    <div class="text-center mb-20">
      <h2 class="text-4xl md:text-5xl lg:text-6xl font-bold">
        <span class="text-am-black">Why</span>
        <span class="text-am-white-60">AddMeetings</span>
      </h2>
      <p class="mt-6 text-[#43444D] max-w-xl mx-auto">
        Stand out from the noise of cold outreach and connect with decision-makers who actually need your solution. AddMeetings helps you focus on relevance over reach making every pitch count and every meeting worthwhile.
      </p>
    </div>

    <!-- Benefits -->
    <div class="space-y-20">
      {#each benefits as benefit, i}
        <div
          class="w-full pt-8 border-t border-am-white-60 flex flex-col sm:flex-row gap-8 items-start justify-between md:px-16 lg:px-24 xl:px-32"
        >
          <h2 class="text-4xl md:text-5xl font-bold">
            <span class="text-am-white-60">{benefit.titleStart}</span>
            <span class="text-am-black">{benefit.titleEnd}</span>
          </h2>

          <p class="text-am-black !font-semibold leading-relaxed sm:max-w-sm text-lg">
            {benefit.description}
          </p>
        </div>
      {/each}
    </div>
  </div>
</section>

<style>
  /* Add smooth transitions */
  div {
    transition: transform 0.2s ease;
  }
  
  .grid:hover {
    transform: translateX(8px);
  }
</style>